import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { useCustomVizBasedLastPersistedRequest } from 'apps/sigma2-ui/src/components/custom-viz/hooks/useCustomVizBasedLastPersistedRequest';
import { PromotionCopilotRequest } from 'libs/end-to-end/src/custom-viz/PromotionCopilotTypes';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { promotionCopilotCustomVizCacheKey } from 'apps/sigma2-ui/src/constants/usable-cache-keys';

export const usePromotionCopilotLastPersistedRequest = ({
  myObservation,
  lastSuccessfulCustomVizRequest,
}: {
  myObservation: MyObservation;
  lastSuccessfulCustomVizRequest: CustomVizRequest | null;
}) =>
  useCustomVizBasedLastPersistedRequest({
    persistKey: promotionCopilotCustomVizCacheKey({
      webCacheKeyPrefix: myObservation.webCacheKeyPrefix,
    }),
    lastSuccessfulCustomVizRequest,
    parseable: PromotionCopilotRequest,
  });
